// ** Third Party Components
import classnames from "classnames";
import { Calendar, Table } from "react-feather";

// ** Reactstrap Imports
import { Button, ButtonGroup } from "reactstrap";

// ** Custom Components
const Header = ({ setActiveView, activeView }) => {
  return (
    <div
      className="view-options d-flex"
      style={{ justifyContent: "flex-end", marginBottom: "1.2rem" }}
    >
      {/* <Breadcrumbs
        title="Application"
        data={[{ title: "Profile" }, { title: "Application" }]}
      /> */}
      <ButtonGroup>
        <Button
          tag="label"
          className={classnames("btn-icon view-btn grid-view-btn", {
            active: activeView === "calendar",
          })}
          color="primary"
          outline
          onClick={() => setActiveView("calendar")}
        >
          <Calendar size={18} />
        </Button>
        <Button
          tag="label"
          className={classnames("btn-icon view-btn list-view-btn", {
            active: activeView === "tableData",
          })}
          color="primary"
          outline
          onClick={() => setActiveView("tableData")}
        >
          <Table size={18} />
        </Button>
      </ButtonGroup>
    </div>
  );
};

export default Header;
